import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const WebsitesAzurePage = () => (
  <MarkdownPage file="WebSitesAzure.md" />
);
